import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import utils from '../../../utils/validateScanner.js'

export default {
	name: 'rto-dto-sticker-tracking',
	mixins: [utils],
	components: {
		VueElementLoading
	},
	data: function() {
		return {
			barcode:'',
			shipmentData:[],
			isLoading: false,
			showTable:false
		}
	},
	created: function() {},
	model: {
	},
	computed: {
	},
	filters: {
		moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
	},
	mounted() {
		this.$refs.barcode.focus();
	},
	methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.$refs.barcode.focus(),
			this.$validator.reset();
    		this.errors.clear();
	  		this.showHideCodeIconInput();
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
        if (result) {
					this.shipmentData=[];
					this.showTable=false; this.isLoading=true;
					axios({
							method: 'GET',
							url: apiUrl.api_url_hubops + 'getRTODTOStickerLogs' + "?FlyerShippingId=" + this.barcode,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',

							}
						})
						.then(result => {
							this.showTable=true;
							if (result.data.ResultCode == 100) {
								// PXB-7142 Shipment Color Code & Icon
								if(Object.keys(result.data.lossCategorization).length !=0){
               					this.colorCode = result.data.lossCategorization.colorCode;
                				this.colorIcon = result.data.lossCategorization.icon;
             			 }
								this.shipmentData=result.data.ResponseData;
							} else {
								this.showHideCodeIconInput();
								this.$alertify.error(result.data.ReturnMessage)
							}
							this.isLoading=false;
						}, error => {
							this.showHideCodeIconInput();
							this.isLoading=false;
							console.error(error)
						})
					}
				});
		}
	},
}



// WEBPACK FOOTER //
// ./src/views/components/RTODTOStickerTracking/RTODTOStickerTracking.js